<template>
  <div class="d-flex flex-row">
    <hr class="flex-grow-1" />
    <div
      class="flex-shrink-1 pt-1"
      :class="big ? 'text-big px-3' : 'px-2'"
      :style="{ marginTop: big ? '-6px' : null }"
    >
      <span v-if="text">{{ tr(text) }}</span>
      <slot />
    </div>
    <hr class="flex-grow-1" />
  </div>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'Divider',
    props: {
      text: { type: String, default: null },
      big: { type: Boolean },
    },
    methods: { tr },
  }
</script>

<style scoped></style>
